module.exports = __webpack_public_path__ + "fj.e9e116090bc2fbdbbab5.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/fj.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/fj.svg
// module chunks = styles